import React, { useState, useEffect } from 'react';

const toastTypes = {
  success: {
    bg: 'bg-green-500',
    text: 'text-white',
    icon: '✅',
    border: 'border-green-600'
  },
  error: {
    bg: 'bg-red-500',
    text: 'text-white',
    icon: '❌',
    border: 'border-red-600'
  },
  warning: {
    bg: 'bg-yellow-500',
    text: 'text-white',
    icon: '⚠️',
    border: 'border-yellow-600'
  },
  info: {
    bg: 'bg-blue-500',
    text: 'text-white',
    icon: 'ℹ️',
    border: 'border-blue-600'
  },
  loading: {
    bg: 'bg-gray-500',
    text: 'text-white',
    icon: '🔄',
    border: 'border-gray-600'
  },
  balance_update: {
    bg: 'bg-purple-500',
    text: 'text-white',
    icon: '💰',
    border: 'border-purple-600'
  },
  transaction: {
    bg: 'bg-indigo-500',
    text: 'text-white',
    icon: '🚀',
    border: 'border-indigo-600'
  }
};

/**
 * Advanced Toast component for notifications
 * ✅ BETA PHASE: Sistema de notificações em desenvolvimento
 */
const Toast = ({ 
  type = 'info', 
  title, 
  message, 
  onClose,
  actions = null,
  details = null
}) => {
  const [visible, setVisible] = useState(true);
  const [isAnimating, setIsAnimating] = useState(false);

  const typeConfig = toastTypes[type] || toastTypes.info;

  useEffect(() => {
    // Entry animation
    setIsAnimating(true);
    const enterTimer = setTimeout(() => setIsAnimating(false), 300);

    return () => clearTimeout(enterTimer);
  }, []);

  const handleClose = () => {
    setVisible(false);
    setTimeout(() => {
      if (onClose) onClose();
    }, 300); // Wait for exit animation
  };

  if (!visible) return null;

  return (
    <div className={`
      w-full pointer-events-auto
      transform transition-all duration-300 ease-in-out
      ${visible ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'}
      ${isAnimating ? 'scale-95' : 'scale-100'}
    `}>
      <div className={`
        ${typeConfig.bg} ${typeConfig.text} ${typeConfig.border}
        border-l-4 rounded-lg shadow-lg overflow-hidden
        backdrop-blur-sm bg-opacity-95
      `}>

        {/* Header */}
        <div className="p-4">
          <div className="flex items-start justify-between">
            <div className="flex items-start space-x-3">
              <span className="text-lg flex-shrink-0 mt-0.5">
                {type === 'loading' ? (
                  <span className="animate-spin inline-block">🔄</span>
                ) : (
                  typeConfig.icon
                )}
              </span>
              <div className="flex-1 min-w-0">
                {title && (
                  <h4 className="text-sm font-semibold mb-1 truncate">
                    {title}
                  </h4>
                )}
                {message && (
                  <p className="text-sm opacity-90 leading-relaxed">
                    {message}
                  </p>
                )}
              </div>
            </div>
            
            {/* Close button */}
            <button
              onClick={handleClose}
              className="flex-shrink-0 ml-2 text-white hover:text-gray-200 transition-colors"
              aria-label="Close notification"
            >
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </button>
          </div>

          {/* Details section */}
          {details && (
            <div className="mt-3 pt-3 border-t border-white border-opacity-20">
              <div className="text-xs opacity-80 space-y-1">
                {Object.entries(details).map(([key, value]) => (
                  <div key={key} className="flex justify-between">
                    <span className="capitalize">{key.replace('_', ' ')}:</span>
                    <span className="font-mono">{value}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

        </div>


      </div>
    </div>
  );
};

export default Toast; 